// extracted by mini-css-extract-plugin
export default {"root":"OneStepBidding-root","bidControls":"OneStepBidding-bidControls","bidControl":"OneStepBidding-bidControl","bidButton":"OneStepBidding-bidButton"};